/**
 * Created by tdunham on 7/14/2017.
 */

import { Injectable } from '@angular/core';

/**
 * Async modal dialog service
 * DialogService makes this app easier to test by faking this service.
 */

@Injectable()
export class DialogService {

	/**
	 * Ask user to confirm an action. `message` explains the action and choices.
	 * Returns promise resolving to `true`=confirm or `false`=cancel
	 */
	confirm(message?: string) {

		return new Promise<boolean>(resolve => {

			return resolve(window.confirm(message || 'Is it OK?'));

		});

	};

}


/*
 Copyright 2017 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that
 can be found in the LICENSE file at http://v2.angular.io/license
 */



// WEBPACK FOOTER //
// ./src/app/services/miscellaneous/dialog-service.ts